<div class="m-subheader" appunwraptag="">
  <div class="d-flex align-items-center">
    <div class="mr-auto">
      <h3 class="m-subheader__title m-subheader__title--separator">
        QP-NOS-Model Curriculum
      </h3>
      <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
        <li class="m-nav__item m-nav__item--home">
          <a href="javascript:;" class="m-nav__link m-nav__link--icon">
            <i *ngIf="initial && initial.icon" [class]="initial.icon"></i>
          </a>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item" *ngIf="initial.b === ''; else elseBlock">
          <a href="javascript:;" class="m-nav__link">
            <span class="m-nav__link-text">
              {{initial.a}}
            </span>
          </a>
        </li>
        <ng-template #elseBlock>
          <li class="m-nav__item">
            <a href="javascript:;" class="m-nav__link">
              <span class="m-nav__link-text">
                {{initial.a}}
              </span>
            </a>
          </li>
          <li class="m-nav__separator" *ngIf="initial.b">
            -
          </li>
          <li class="m-nav__item">
            <a href="javascript:;" class="m-nav__link">
              <span class="m-nav__link-text">
                {{initial.b}}
              </span>
            </a>
          </li>
        </ng-template>
      </ul>
    </div>
    <div>

    </div>
  </div>
</div>